import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Navbar from '../layout/Navbar';
import Preloader from '../layout/preloader';
import EventoTopo from '../section-pages/evento-topo'; 
import EventoTexto from '../section-pages/evento-texto';
import CursosSeminariosInscricao from '../section-pages/cursos-seminarios-inscricao';
import Footer from '../section-pages/footer';
import ScrollToTopBtn from '../layout/ScrollToTop';
import ApiEvento from '../services/eventoService';

export default function Evento() {
  const image1 = './img/background/subheader-game.webp';
  const { slug } = useParams();
  const [evento, setEvento] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchEvento = async () => {
    try {
      const response = await ApiEvento.obterPorUrl(slug);
      setEvento(response.data.evento[0]);
    } catch (error) {
      console.error('Erro ao buscar evento:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchEvento();
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const loader = document.getElementById('mainpreloader');
      if (loader) {
        setTimeout(() => {
          loader.classList.add('fadeOut');
          loader.style.display = 'none';
        }, 600);
      }
    }
  }, []);

  // Verificação de período de inscrição
  const inscricaoAberta = (() => {
    if (!evento?.inicioInscricao || !evento?.fimInscricao) return false;

    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);

    const inicio = new Date(evento.inicioInscricao);
    inicio.setHours(0, 0, 0, 0);

    const fim = new Date(evento.fimInscricao);
    fim.setHours(23, 59, 59, 999);

    return hoje >= inicio && hoje <= fim;
  })();

  return (
    <>
      {/* HEAD */}
      <Helmet>
        <link rel="icon" href="./img/icon.png" />
        <title>Fetron - Federação de Taekwondô de Rondônia</title>
      </Helmet>

      {/* LOADER */}
      <div id="mainpreloader">
        <Preloader />
      </div>

      {/* MENU */}
      <div className="home dark-scheme">
        <header id="header-wrap">
          <Navbar />
        </header>

        <section>
          {evento ? (
            <EventoTopo evento={evento} />
          ) : (
            <p>Carregando evento...</p>
          )}
        </section>

        <section className="noticia-section">
          {evento ? (
            <EventoTexto evento={evento} />
          ) : (
            <p>Carregando dados do evento...</p>
          )}
        </section>

        {evento?.tipoEvento === 2 && inscricaoAberta && (
          <section className="noticia-section">
            <CursosSeminariosInscricao evento={evento} />
          </section>
        )}
        
        {evento?.tipoEvento !== 2 && inscricaoAberta && (
          <section className="noticia-section">'
            <center>
              <Link to={`/evento-inscricao/${slug}`} className="btn-main opt-1">Inscreva-se</Link>
            </center>
          </section>
        )}

        {/* Footer */}
        <Footer />
      </div>

      <ScrollToTopBtn />
    </>
  );
}
